const AnnualReportsDashboardDataSelector = ({
  annualReportsData:
  { AnnualReportDashboardData }
}) => AnnualReportDashboardData;

export default AnnualReportsDashboardDataSelector;